import { render, staticRenderFns } from "./IdVerificationInternal.vue?vue&type=template&id=488034fc&"
import script from "./IdVerificationInternal.vue?vue&type=script&lang=js&"
export * from "./IdVerificationInternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports